import { render, staticRenderFns } from "./RFIDReaderListener.vue?vue&type=template&id=4e4bfbc4&"
import script from "./RFIDReaderListener.vue?vue&type=script&lang=ts&"
export * from "./RFIDReaderListener.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports